import React, { useState, useContext, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Trans } from "react-i18next";
import { AuthContext } from "../Context/AuthContext";

const Navbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { clearAuth, name, role } = useContext(AuthContext);

  const navigate = useNavigate();

  const toggleOffcanvas = () => {
    setSidebarOpen(!sidebarOpen);
    document.querySelector(".sidebar-offcanvas").classList.toggle("active");
  };
  useEffect(() => {
    if (["Super Admin", "DFO", "CCF", "FRO"].includes(role)) {
      document.body.classList.add("sidebar-icon-only");
    }
  }, [role]);

  const handleLogout = () => {
    clearAuth();
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login-1");
  };

  const navigateToActivityLog = () => {
    navigate("/activity-log");
  };

  return (
    <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <Link className="navbar-brand brand-logo" to="/dashboard">
          VFC
        </Link>
        <Link className="navbar-brand brand-logo-mini" to="/dashboard">
          <img src={require("../../assets/images/Logo_vfc.png")} alt="logo" />
        </Link>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-stretch">
        <button
          className="navbar-toggler navbar-toggler align-self-center"
          type="button"
          onClick={() => document.body.classList.toggle("sidebar-icon-only")}
        >
          <span className="mdi mdi-menu"></span>
        </button>
        <div className="search-field d-none d-md-block">
          <form className="d-flex align-items-center h-100" action="#">
            <div className="input-group">
              <div className="input-group-prepend bg-transparent">
                <i className="input-group-text border-0 mdi mdi-magnify"></i>
              </div>
              <input
                type="text"
                className="form-control bg-transparent border-0"
                placeholder="Search projects"
              />
            </div>
          </form>
        </div>
        <ul className="navbar-nav navbar-nav-right">
          <li className="nav-item nav-profile">
            <Dropdown alignRight>
              <Dropdown.Toggle className="nav-link">
                <div className="nav-profile-img">
                  <img
                    src={require("../../assets/images/faces/face1.jpg")}
                    alt="user"
                  />
                  <span className="availability-status online"></span>
                </div>
                <div className="nav-profile-text">
                  <p className="mb-1 text-black">
                    <Trans>{name}</Trans>
                  </p>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="navbar-dropdown">
                {role === "Admin" && (
                  <Dropdown.Item onClick={navigateToActivityLog}>
                    <i className="mdi mdi-cached mr-2 text-success"></i>
                    <Trans>Activity Log</Trans>
                  </Dropdown.Item>
                )}

                <Dropdown.Item href="!#" onClick={handleLogout}>
                  <i className="mdi mdi-logout mr-2 text-primary"></i>
                  <Trans>Signout</Trans>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li>

          <li className="nav-item nav-logout d-none d-lg-block">
            <a className="nav-link" href="!#" onClick={handleLogout}>
              <i className="mdi mdi-power"></i>
            </a>
          </li>

          <li className="nav-item nav-settings d-none d-lg-block">
            {/* <button
              type="button"
              className="nav-link border-0"
              onClick={toggleRightSidebar}
            >
              <i className="mdi mdi-format-line-spacing"></i>
            </button> */}
          </li>
        </ul>
        <button
          className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          onClick={toggleOffcanvas}
        >
          <span className="mdi mdi-menu"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
